import React from "react";
import { Dropdown, Layout } from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./GeneralHeader.less";
import { useAuth } from "../../../hooks/auth/AuthContext";
import LanguageSwitcher from "../../widgets/language-switcher/LanguageSwitcher";
import { useIntl } from "react-intl";
const { Header } = Layout;

const GeneralHeader = ({ logout }: any) => {
  const { authState } = useAuth();
  const intl = useIntl();
  const name =
    authState.userProfile && authState.userProfile?.name
      ? authState.userProfile?.name
      : "";

  const items: any = [
    {
      key: "m-dd-1",
      icon: <UserOutlined />,
      label: (
        <>
          <Link to="/profile">
            {intl.formatMessage({ id: "PROFILE" })}
          </Link>
        </>
      ),
    },
    {
      key: "m-dd-2",
      icon: <LogoutOutlined />,
      label: <>{intl.formatMessage({ id: "LOGOUT" })}</>,
      onClick: logout,
    },
  ];

  return (
    <div className="site-layout-header-container">
      <Header className="site-layout-header" style={{ padding: 0 }}>
        <div>
          <LanguageSwitcher />
          <Dropdown
            menu={{ items }}
            className="profile-menu"
            trigger={["hover", "click"]}
          >
            <div style={{ color: "#1890ff", display: "flex", alignItems: "center", gap: 10 }}>
              <UserOutlined style={{ fontSize: 20 }} />
              <span className="profile-menu-title">{name}</span>
            </div>
          </Dropdown>
        </div>
      </Header>
    </div>
  );
};

export default GeneralHeader;
